import agwaEmptyStateStyles from './agwa-empty-state.styles.css?inline';
import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';

@customElement('agwa-empty-state')
export class AgwaEmptyState extends LitElement {
  static styles = unsafeCSS(agwaEmptyStateStyles);

  @property() icon: string = 'info-circle';
  @property() title: string = '';
  @property() message: string = '';

  render() {
    return html`<div class="wrapper" role="status" aria-live="polite">
      <div class="icon"><sl-icon name="${this.icon}"></sl-icon></div>
      ${this.title ? html`<div class="title">${this.title}</div>` : ''}
      ${this.message ? html`<div class="message">${this.message}</div>` : ''}
      <slot></slot>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'agwa-empty-state': AgwaEmptyState;
  }
}
